import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Row, Col } from 'react-bootstrap';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import '../css/tabs.css';
import { peopleVideo } from './Includes/meetPeople';
import ControlledCarousel from './carousel';

const TITLE = "Meet our people - XL Dynamics India Pvt. Ltd";

class MeetOurPeople extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: 0
    };
  }

  setSelected(e, index) {
    e.preventDefault();
    this.setState({ selected: index });
  }

  renderItem(item, key) {
    return (
      <CSSTransition
        key={`peopleVideo-${key}`}
        timeout={500}
        classNames="fade"
      >
        <div
          className={`item col-12${item.category === 'WOMEN AT XLD' ? ' woman' : ''}`}
          style={{ backgroundColor: item.color }}
        >
          {item.info.map((emp, idx) => (
            <div className="video-block col-sm-4 col-md-4 col-lg-2" key={idx}>
              <a href={emp.video} target="_blank" rel="noopener noreferrer">
                <img src={emp.src} alt={emp.employee} />
              </a>
              {item.category !== 'WOMEN AT XLD' && (
                <>
                  <strong>{emp.employee}</strong>
                  <span>{emp.team}</span>
                </>
              )}
            </div>
          ))}
        </div>
      </CSSTransition>
    );
  }

  render() {
    const selectedItem = peopleVideo[this.state.selected];
    return (
      <React.Fragment>
        <Helmet>
          <title>{TITLE}</title>
        </Helmet>
        <Row className="removeMarginLR meet-our-people">
          <Col xs={1}></Col>
          <Col xs={12} md={10} sm={12}>
            <div className="x-head">MEET OUR <span style={{ color: "#bb0909" }}>PEOPLE</span></div>
            <div className="app">
              <div className="nav">
                {peopleVideo.map((item, key) => {
                  const activeClass = key === this.state.selected ? 'active' : '';
                  return (
                    <a
                      className={`${activeClass} select`}
                      key={item.color}
                      onClick={e => this.setSelected(e, key)}
                    >
                      <span>{item.category}</span>
                    </a>
                  );
                })}
              </div>
              <div className="items">
                <TransitionGroup>
                  {this.renderItem(selectedItem, this.state.selected)}
                </TransitionGroup>
              </div>
            </div>
          </Col>
          <Col xs={1}></Col>
        </Row>
        <Row className="text-center make-center slider-panel">
          <ControlledCarousel />
        </Row>
      </React.Fragment>
    );
  }
}

export default MeetOurPeople;
